module.exports = __webpack_public_path__ + "img/building95-4.57f81516.jpg";